/*eslint no-alert:0 */
import React, { useCallback, useMemo, useState } from "react";
import MaskedInput from "react-input-mask";

import { useDispatch } from "react-redux";

import { SaveTable, Row } from "../DataTable.jsx";
import { useParams } from "react-router";
import { siteCreate, siteRemove } from "../store/sitesSlice.js";

export const ReauthPanel = () => {

    const dispatch = useDispatch();
    const params = useParams();

    const [key, setKey] = useState("");
    const [error, setError] = useState(null);

    const isKeyValid = useMemo(() => (/^[0-9]{4}$/).test(key), [key]);

    const onAddPanel = useCallback(() => {
        dispatch(siteCreate(params.hwaddr, key)).then(() => {
            location.href="/#/";

        }, err => setError(err.toString()) );
    }, [key]);

    const onRemove = useCallback(() => {
        if (confirm("Remove this panel")) {
            dispatch(siteRemove(params.hwaddr)).then(() => {
                location.href="/#/";

            },  err => setError(err.toString()) );
        }
    }, [params.hwaddr])

    return (
        <div className="container">
            <div className="row">
                {error ? (<div className="col-md-6 col-md-offset-3">
                    <div className="alert alert-danger" role="alert" id="error-message">{error}</div>
                </div>) : null}
                <SaveTable disabled={!isKeyValid} onSave={onAddPanel} buttonLabel="Update">
                    <Row label="MAC address">
                        {params.hwaddr.match(/[0-9a-f]{2}/g).join(":")}
                    </Row>
                    <Row label="Admin password">
                        <MaskedInput
                            value={key}
                            onChange={ ev => setKey(ev.target.value) }
                            autoComplete="off"
                            required
                            pattern="[0-9]{4}"
                            mask="9999"
                            name="panel-password"
                            className="form-control"
                            placeholder="e.g. 9965"
                            title="Please enter the panel's engineer password"
                        />
                    </Row>
                </SaveTable>
            </div>
            <div className="row">
                <div className="col-md-6 col-md-offset-3">
                    <button
                        type="button"
                        className="btn btn-danger btn-lg btn-block"
                        onClick={onRemove}
                    >Remove</button>
                </div>
            </div>
        </div >
    );
}
